import React from 'react';
import {connect} from 'react-redux';
import {localized} from '../../../../state/i18n/i18n';
import * as DeviceDatesActions from '../../../../state/ducks/devices/operations';
import {DateRangePicker} from '../../default-components/date-range-picker/date-range-picker';
import DeviceGraph from '../teracom-device-graph';
import './style.scss';

const mapStateToProps = (state) => {
  return {
    dateFrom: state.devicesReducer.dateFrom,
    dateTo: state.devicesReducer.dateTo,
  };
};

class DeviceContentContainer extends React.PureComponent {
  render() {
    const {devices, dateFrom, dateTo, devicesData} = this.props;
    return (
      <div>
        <div className={'topContainer justifyContentStart contentTitleContainer'}>
          <div className="contentTitle">{localized('Graphs')}</div>
        </div>
        <div className="graphMargin">
          <div className={'displayFlex padding datePicker'}>
            <DateRangePicker dateFrom={dateFrom} dateTo={dateTo} dateChanged={this.DateRangeChanged} />
          </div>

          <DeviceGraph devices={devices} devicesData={devicesData} dateFrom={dateFrom} dateTo={dateTo} />
        </div>
      </div>
    );
  }

  DateRangeChanged = (dateFrom, dateTo) => {
    let fromDate = dateFrom;
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);

    let toDate = dateTo;
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);

    this.props.setDevicesDates(fromDate, toDate);
  };
}

export default connect(mapStateToProps, DeviceDatesActions)(DeviceContentContainer);
